module.exports = __webpack_public_path__ + "media/images/index/video-b2d0a70de84cf6fa7f7482ec380df811.svg";